import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables,
    isEmptyVariable, isEmptyArray,
    validateFile,
    handleTokenExpiry} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import SpinnerLoader from 'react-loader-spinner';
import {DialogSaveButton,UploadSampleLayout} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();

class UploadDocumentSample extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,
            submitClickedAtleastOnce:false,
            uploadFileArr:[
                {
                    fileName:"",
                    originalFileName:"",
                    fileId:"file_1",
                    isUploading:false,
                    // remark:"",
                    newlyAdded:true,
                    errors:{}
                }
            ],
            apiErr:"",
            uniqueIdCount:1,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showUploadReportDialog){
            this.setState({
                componentDidMountFlag:false,
                showLoader:false,
                submitClickedAtleastOnce:false,
                uploadFileArr:[
                    {
                        fileName:"",
                        originalFileName:"",
                        fileId:"file_1",
                        isUploading:false,
                        // remark:"",
                        newlyAdded:true,
                        errors:{}
                    }
                ],
                apiErr:"",
                uniqueIdCount:1,
                showAlertDialogInfo:false,
                alertDialogMessageInfo:""
            })
        }
    }

    // handleChange = (e) => {
    //     const { name, value } = e.target;
    //     let uploadFileArrTemp = this.state.uploadFileArr;
    //     uploadFileArrTemp[name].remark = value;

    //     if(this.state.submitClickedAtleastOnce){
    //         if(!isEmptyVariable(uploadFileArrTemp[name].remark) && 
    //         uploadFileArrTemp[name].remark.length > Constants.REMARKS_STRING_LENGTH){
    //             uploadFileArrTemp[name].errors['remark'] = "Remarks must be less then "+Constants.REMARKS_STRING_LENGTH+" characters";
    //         }else{
    //             uploadFileArrTemp[name].errors['remark'] = "";
    //         }
    //     }

    //     this.setState({
    //         uploadFileArr:uploadFileArrTemp,
    //     })
    // }
    handleAlertDialogCloseInfo = () =>{
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        });
    }

    handleAddNewClick = () => {
        let uniqueIdCount = this.state.uniqueIdCount + 1;
        let newObj = {
            fileName:"",
            originalFileName:"",
            fileId:"file_"+uniqueIdCount,
            isUploading:false,
            // remark:"",
            newlyAdded:true,
            errors:{}
        }
        let uploadFileArrTemp = this.state.uploadFileArr;
        uploadFileArrTemp.push(newObj);

        this.setState({
            uploadFileArr:uploadFileArrTemp,
            uniqueIdCount:uniqueIdCount
        })
    }

    handleDeleteItemClick = (index) => {
        let uploadFileArrTemp = this.state.uploadFileArr;
        uploadFileArrTemp.splice(index,1);
        this.setState({
            uploadFileArr:uploadFileArrTemp,
        })
    }

    handleUploadReportDialogClose = () =>{
        this.props.handleUploadReportDialogClose(false);
    }
    
    uploadReportDocumentsApi = () => {
        this.setState({
            submitClickedAtleastOnce:true,
            showLoader:true,
        });
        
        let isError = false;
        let apiErrTemp = "";
        let uploadFileArrTemp = this.state.uploadFileArr;

        uploadFileArrTemp.map((item,index)=>{
            if(item.isUploading){
                isError = true;
                apiErrTemp = "Files are being uploaded. Please wait";
            }

            if(isEmptyVariable(item.fileName)){
                isError = true;
                uploadFileArrTemp[index].errors['uploadFileErr'] = "Please upload a file";
            }

            // if(!isEmptyVariable(item.remark)){
            //     if(item.remark > Constants.REMARKS_STRING_LENGTH){
            //         isError = true;
            //         uploadFileArrTemp[index].errors['remark'] = "Remarks must be less then "+Constants.REMARKS_STRING_LENGTH+" characters";
            //     }

            // }
        })

        if(isError){
            this.setState({
                uploadFileArr:uploadFileArrTemp,
                apiErr:apiErrTemp,
                showLoader:false
            });
        }else{
            //return uploadFileArr
            // this.props.returnUploadedArray(this.state.uploadFileArr);
            let tmpReportFileArr = [];
            this.state.uploadFileArr.forEach((item,index)=>{
                let fileObj = {
                    fileName:item.fileName,
                    name:item.originalFileName,
                    description:"",
                }
                tmpReportFileArr.push(fileObj);
            })
            let postParams = {
                email:userDetails.email,
                accessToken:userDetails.accessToken,
                assignmentId:this.props.assignmentId,
                tmpFileArr:JSON.stringify(tmpReportFileArr),
                forCompleted:true
                // delTmpFileArr:JSON.stringify([]),
            }
            fetch(Constants.SaveReportUpload,
                {
                    method: "POST",
                    mode:'cors',
                    body: new URLSearchParams(postParams)
                })
                .then(response => { return response.json(); } )
                .then(data =>
                {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        this.setState({
                            showLoader:false,
                        },() => {
                            this.props.handleUploadReportDialogClose(true);
                        });
                    }else{
                        this.setState({
                            showLoader:false,
        
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage,
                        })
                    }
                });
        }
    }

    handleUploadReportFile = async (index, e) => {
        e.preventDefault();

        const input = e.target;
        const file = input.files?.[0]; // Save the file immediately
        if (!file) return;

        const result = await validateFile(file);
        let uploadFileArrTemp = [...this.state.uploadFileArr];
        let fileSlot = uploadFileArrTemp[index];

        if(!isEmptyVariable(file)){
            // let uploadFileArrTemp = this.state.uploadFileArr;
            fileSlot.isUploading=true;
            fileSlot.originalFileName=file.name;

            this.setState({
                uploadFileArr:uploadFileArrTemp,
            })

            if(!result.valid){
                fileSlot.isUploading=false;
                fileSlot.originalFileName="";
                fileSlot.errors.uploadFileErr = result.message;
                this.setState({
                    uploadFileArr:uploadFileArrTemp,
                });
            }else{
                const formData = new FormData();
                formData.append('documentSample',file);
                formData.append('email',userDetails.email);
                formData.append('accessToken',userDetails.accessToken);
                formData.append('forCompleted',true);

                let url = "";
                url = Constants.UploadReport;
                // if(this.props.isDraftOnward === true){
                //     if(this.props.type == "Annexure"){
                //     }else if(this.props.type == "Backup"){
                //         url = Constants.UploadDraftBackup;
                //     }
                // }else{
                //     if(this.props.type == "Annexure"){
                //         url = Constants.UploadAnnexure;
                //     }else if(this.props.type == "Backup"){
                //         url = Constants.UploadBackup;
                //     }
                // }

                fetch(url,
                {
                    method: "POST",
                    mode: 'cors',
                    body: formData
                })
                .then(response => { return response.json(); })
                .then(data => {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        fileSlot.isUploading=false;
                        fileSlot.fileName=data.fileName;
                        fileSlot.errors={};
                        this.setState({
                            uploadFileArr:uploadFileArrTemp,
                        });
                    }else{
                        fileSlot.isUploading=false;
                        fileSlot.originalFileName="";
                        // fileSlot.errors.uploadFileErr=data.responseMessage;
                        this.setState({
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage
                        })
                    }
                });
            }
        }
    }

    render() {
        return(
            <Modal className="upload-doc-sample-dialog custom-dialog" 
            show={this.props.showUploadReportDialog} backdrop="static">
                <Modal.Header>
                    <h5>Upload Report</h5>
                    <button 
                        onClick={this.handleUploadReportDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div className="modal-body">
                    {
                        this.state.showLoader &&
                        <div class="loader"></div>
                    }
                    <div className="addnew-modal-form">
                    {
                        !isEmptyArray(this.state.uploadFileArr) &&
                        this.state.uploadFileArr.map((item,index) => {
                            return <div className="row custom-row">
                                    <div className="col-md-12 custom-col">
                                        <div className="addnew-modal-form-group  m-b-10">
                                            <p>Report Document*</p>
                                            <div className="flex-center-layout">
                                                <input type="text" placeholder="Select Report Document"
                                                    value={item.originalFileName}
                                                    disabled={true}
                                                />
                                                <UploadSampleLayout themeSettings={this.props.themeSettings}>
                                                    <input name="file" 
                                                        type="file"
                                                        id={item.fileId}
                                                        onChange={this.handleUploadReportFile.bind(this,index)}
                                                        disabled={item.isUploading}
                                                    />
                                                    <label disabled={item.isUploading} for={item.fileId}>Upload Report</label>
                                                </UploadSampleLayout>
                                                {
                                                    index !== 0 &&
                                                    <span className="material-icons delete-doc-row"
                                                    onClick={this.handleDeleteItemClick.bind(this,index)}>
                                                        delete
                                                    </span>
                                                }
                                            </div>
                                            {
                                                !isEmptyVariable(item.errors['uploadFileErr']) &&
                                                <span class="cm-error">{item.errors['uploadFileErr']}</span>
                                            }
                                            {
                                                item.isUploading &&
                                                <div className="flex-center-layout single-line m-t-5">
                                                    <SpinnerLoader style={{ marginLeft:5 }} 
                                                        type={Constants.LOADER_TYPE} color={Constants.LOADER_COLOR} height={20} width={30} />
                                                    <span class="loading-span" style={{ marginLeft:5 }}>Uploading document</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {/* <div className="col-md-12 custom-col">
                                        <div className="addnew-modal-form-group m-b-0">
                                            <p>Remarks</p>
                                            <textarea type="text" placeholder="Enter Remarks"
                                            name={index} value={item.remark} onChange={this.handleChange}/>
                                            {
                                                !isEmptyVariable(item.errors['remark']) &&
                                                <span className="cm-error">{item.errors['remark']}</span>
                                            }
                                        </div>
                                    </div> */}
                                    {
                                        (index !== (this.state.uploadFileArr.length - 1)) &&
                                        <hr className="doc-upload-divider"/>
                                    }
                                    
                                </div>
                            })
                        }
                        <div className="row custom-row">
                            <div className="col-md-12 custom-col">
                                <div className="add-more-btn-layout" onClick={this.handleAddNewClick}>
                                    <span className="material-icons">add_circle</span>
                                    <p>Add New</p>
                                </div>
                            </div>
                        </div>
                        {
                            !isEmptyVariable(this.state.apiErr) &&
                            <span className="cm-error">{this.state.apiErr}</span>
                        }
                    </div>
                    
                    <div className="modal-close-save">
                        <div className="close-save-col">
                            <button onClick={this.handleUploadReportDialogClose} type="button" className="modal-close">Cancel</button>
                            <DialogSaveButton
                            themeSettings={this.props.themeSettings}
                            onClick={this.uploadReportDocumentsApi} type="button">Save</DialogSaveButton>
                        </div>
                    </div>
                    <AlertDialog 
                        showAlertDialog={this.state.showAlertDialogInfo}
                        handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                        type= {Constants.ALERT_TYPE_ALERT}
                        alertDialogMessage={this.state.alertDialogMessageInfo}
                        proceedBtnClick={this.handleAlertDialogCloseInfo}
                        proceedBtnLabel={ Constants.ALERT_TYPE_OKAY_LABEL }
                        themeSettings={this.props.themeSettings}
                    />
                </div>
            </Modal>
        );
    }
}

export default UploadDocumentSample;